<template>
	<div class="card settings">
		<div class="card__header">
			<h4 class="card__title">Настройки аккаунта</h4>
		</div>
		<div class="card__body" v-if="user">
			<div class="settings__row settings__head-info">
				<div class="settings__col">
					<div class="settings__theme">
						<h6 class="settings__theme-title">Темная тема</h6>
						<label class="switch settings__theme-switch">
							<input class="switch__input" v-model="$root.darkTheme" autocomplete="off" type="checkbox">
							<span class="switch__btn"></span>
						</label>
					</div>
				</div>
				<div class="settings__col">
					<div class="badge badge--md badge--lighter">Для вывода нужно отыграть: {{user.wager}}</div>
					<div class="settings__note">
						<router-link to="/faq#wager-balance"><b>Правила отыгрыша</b></router-link>
					</div>

				</div>
				<div v-if="user.rang" class="settings__col">
					<div class="settings__rang">Ваш ранг:
						<router-link :to="{name: 'rang'}" class="settings__rang-link" target="_blank">
							<img :src="user.rang.icon_url" class="settings__rang-image">
							{{ user.rang.title }}
						</router-link>
					</div>
				</div>
			</div>
			<hr>

			<h6 class="settings__subtitle" v-if="!this.user.old_username">Изменение никнейма</h6>
			<div class="settings__row" v-if="!this.user.old_username">
				<div class="settings__col">
					<input type="password" v-model="username" name="username" class="text-field__input"
						placeholder="Введите новый никнейм" autocomplete="off" required="">
					<div class="text-field__success" v-if="successChangeNick">
						Никнейм изменен
					</div>
				</div>
				<div class="settings__col">
					<button @click="editUser" class="btn btn--block btn--primary"
						:disabled="disableBtn1">Сменить</button>
				</div>
			</div>

			<hr>

			<h6 class="settings__subtitle" v-if="user.has_password">
				Изменение пароля
			</h6>
			<div class="settings__row" v-if="user.has_password">
				<div class="settings__col">
					<input type="password" v-model="oldPassword" name="firstname" class="text-field__input"
						placeholder="Старый пароль" autocomplete="off" required="">
				</div>
				<div class="settings__col">
					<input type="password" v-model="newPassword" name="lastname" class="text-field__input"
						placeholder="Новый пароль" autocomplete="off" required="">
					<div class="text-field__success" v-if="successChangePassword">
						Пароль изменен
					</div>
				</div>
				<div class="settings__col">
					<button @click="resetPassword" class="btn btn--primary btn--block" :disabled="disableBtn">Изменить
						пароль</button>
				</div>
			</div>

			<h6 class="settings__subtitle" v-if="!user.has_password">Установить пароль</h6>
			<div class="settings__row" v-if="!user.has_password">
				<div class="settings__col">
					<input type="password" v-model="setPass" name="firstname" placeholder="Новый пароль"
						class="text-field__input" autocomplete="off" required="">
					<div class="text-field__success" v-if="successSetPass">
						Пароль установлен
					</div>
				</div>
				<div class="settings__col">
					<button @click="setPassword" class="btn btn--block btn--primary"
						:disabled="disableBtn2">Сохранить</button>
				</div>
			</div>

			<hr>

			<div class="settings__row">
				<div class="settings__col">
					<button v-if="user.vkontakte" disabled class="btn btn--lg btn--outline-vkontakte btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-vk"></use>
						</svg>
						{{ user.vkontakte.full_name ?? user.vkontakte.username }}
					</button>
					<button v-if="!user.vkontakte" @click="$root.OAuth('vkontakte')"
						class="btn btn--lg btn--outline-vkontakte btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-vk"></use>
						</svg>
						Привязать Вконтакте
					</button>
				</div>
				<div class="settings__col">
					<button v-if="user.telegram" disabled class="btn btn--lg btn--outline-telegram btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-tg"></use>
						</svg>
						{{ user.telegram.full_name ?? user.telegram.username }}
					</button>
					<button v-if="!user.telegram" @click="$root.OAuth('telegram')"
						class="btn btn--lg btn--outline-telegram btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-tg"></use>
						</svg>
						Привязать Телеграм
					</button>
				</div>
				<div class="settings__col">
					<button v-if="user.google" disabled class="btn btn--lg btn--outline-google btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-google"></use>
						</svg>
						{{ user.google.full_name ?? user.google.username }}
					</button>
					<button v-if="!user.google" @click="$root.OAuth('google')"
						class="btn btn--lg btn--outline-google btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-google"></use>
						</svg>
						Привязать Google
					</button>
				</div>
			</div>
			<hr>

			<div class="settings__row">
				<div class="settings__col">
					<button v-if="user.mailru" disabled class="btn btn--lg btn--outline-mailru btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-mailru"></use>
						</svg>
						{{ user.mailru.full_name ?? user.mailru.username }}
					</button>
					<button v-if="!user.mailru" @click="$root.OAuth('mailru')"
						class="btn btn--lg btn--outline-mailru btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-mailru"></use>
						</svg>
						Привязать mail.ru
					</button>
				</div>

				<div class="settings__col">
					<button v-if="user.yandex" disabled class="btn btn--lg btn--outline-yandex btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-yandex"></use>
						</svg>
						{{ user.yandex.full_name ?? user.yandex.username }}
					</button>
					<button v-if="!user.yandex" @click="$root.OAuth('yandex')"
						class="btn btn--lg btn--outline-yandex btn--block">
						<svg class="btn__icon" height="14" width="14">
							<use href="#svg-icon-yandex"></use>
						</svg>
						Привязать yandex
					</button>
				</div>
			</div>
			<hr>
			<div class="settings__row">
				<button type="submit" class="btn btn--lg btn--block btn--danger settings__col"
					@click="$root.emitter.emit('logout')">Выйти из аккаунта</button>
			</div>
		</div>
	</div>
</template>

<script>

import { mapState } from 'pinia';
import { useUserStore } from '../../stores/User';
import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";

export default {
	mixins: [
		breakpointsMixin
	],

	data() {
		return {
			oldPassword: '',
			newPassword: '',
			username: '',
			setPass: '',
			disableBtn: false,
			successChangePassword: false,
			disableBtn1: false,
			successChangeNick: false,
			disableBtn2: false,
			successSetPass: false,
		}
	},
	computed: {
		...mapState(useUserStore, ['user']),
	},
	methods: {
		resetPassword() {
			if(!this.oldPassword) {
				return this.$toast.error('Введите старый пароль');
			}
			if(!this.newPassword) {
				return this.$toast.error('Введите новый пароль');
			}
			this.disableBtn = true;
			this.$root.axios.post('api/user/password/change', {
				current_password: this.oldPassword,
				new_password: this.newPassword
			}).then((response) => {
				if(response.data.success) {
					this.disableBtn = false;
					this.successChangePassword = true;
				}
			}).catch(error => {
				this.$toast.error(this.$root.graphql.axiosGetError(error));
				this.disableBtn = false;
			});
		},
		editUser() {
			if(!this.username) {
				return this.$toast.error('Введите новый ник');
			}
			this.disableBtn1 = true;
			this.$root.axios.post('api/user/username', {
				'username': this.username
			}).then((response) => {
				const data = response.data;
				if(data.success) {
					this.disableBtn1 = false;
					this.successChangeNick = true;
					this.$root.getUser();
				} else {
					this.$toast.error(data.message);
				}
			}).catch(error => {
				this.disableBtn1 = false;
				this.$toast.error(this.$root.graphql.axiosGetError(error));
				this.disableBtn = false;
			});
		},
		setPassword() {
			if(!this.setPass) {
				return this.$toast.error('Введите новый пароль');
			}
			this.disableBtn2 = true;
			this.$root.axios.post('api/user/password/set', {
				password: this.setPass
			}).then((response) => {
				if(response.data.success) {
					this.disableBtn2 = false;
					this.successSetPass = true;
					this.$root.getUser();
				}
			}).catch(error => {
				this.$toast.error(this.$root.graphql.axiosGetError(error));
				this.disableBtn2 = false;
			});
		}
	}
}
</script>
